<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
      <v-container fluid style="margin: 0px; padding: 0px; width: 100%">
        <v-row>
          <v-text-field
            label="Name"
            v-model="personDetails.name"
            :rules="nameRules"
            required
            light
          ></v-text-field>
        </v-row>
        <v-row>
          <v-text-field
            label="Type"
            v-model="personDetails.type"
            :rules="typeRules"
            required
            light
          ></v-text-field>
        </v-row>

        <template v-for="(item, idx) in existingWebsites">
          <v-row v-bind:key="idx + 'existing'" align="center">
            {{item.url}}
            <v-spacer></v-spacer>
            <v-btn icon>
              <v-icon color="grey" @click="openUrl(item.url)">mdi-arrow-top-right</v-icon>
            </v-btn>
            <v-btn icon>
              <v-icon color="grey" @click.stop="markWebsiteAsDeleted(idx)">mdi-delete</v-icon>
            </v-btn>
          </v-row>
        </template>

        <template v-for="(item, idx) in websites">
          <v-row v-bind:key="idx + 'new'" align="center">
            <v-text-field
              label="Website"
              v-model="websites[idx].url"
              :rules="urlRules"
              light
            ></v-text-field>
            <v-btn icon>
              <v-icon color="grey" @click="openUrl(item.url)">mdi-arrow-top-right</v-icon>
            </v-btn>
            <v-btn icon>
              <v-icon color="grey" @click.stop="removeWebsiteInputRow(idx)">mdi-delete</v-icon>
            </v-btn>
          </v-row>
        </template>

        <v-row>
          <v-btn
            color="blue"
            text
            style="padding: 0px;"
            @click="addWebsiteInputRow()"
          >+website</v-btn>
        </v-row>
        <v-row v-if="!isLoading">
          <v-btn
            block
            color="primary"
            outlined
            rounded
            style="margin-top: 16px;"
            @click="savePerson()"
          >{{isEditing ? 'Save' : 'Add'}}</v-btn>
        </v-row>
        <v-row v-if="isLoading" justify="center">
          <v-progress-circular
            indeterminate
            color="blue"
          ></v-progress-circular>
        </v-row>
      </v-container>

    </v-form>
</template>

<script>
const firebaseApp = require('firebase/app');

export default {
  props: ['person', 'isEditing'],
  data() {

    let validURL = function (str) {
      var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
        '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
      return !!pattern.test(str);
    };

    return {
      valid: true,
      isLoading: false,
      personDetails: {
        name: '',
        type: '',
      },
      websites: [{
        url: '',
      }],
      existingWebsites: [],
      deletedWebsites: [],
      uid: this.$root.$data.appStore.state.user.uid,
      websitesQuery: this.isEditing && this.$root.$data.db.collection('person').doc(this.$route.params.id).collection('website').orderBy('created', 'desc'),
      userDocQuery: this.$root.$data.db.collection('user').doc(this.$root.$data.appStore.state.user.uid),
      nameRules: [
        v => !!v || 'Name is required',
      ],
      typeRules: [
        v => !!v || 'Type is required',
      ],
      urlRules: [
        v => validURL(v) || !v || 'Website invalid',
      ],
    };
  },
  methods: {
    addWebsiteInputRow() {
      this.websites.push({
        url: '',
      });
    },
    removeWebsiteInputRow(idx) {
      this.websites.splice(idx, 1);
    },
    markWebsiteAsDeleted(idx) {
      let website = this.existingWebsites[idx];
      this.deletedWebsites.push(website);
      this.existingWebsites.splice(idx, 1);
    },
    async fetchPersonWebsites () {
      this.isLoading = true;
      let websites = [];

      let querySnapshot;
      try {
        querySnapshot = await this.websitesQuery.get();
      } catch (error) {
        console.error("Error getting documents: ", error);
        return;
      }

      querySnapshot.forEach((doc) => {
        websites.push({
          id: doc.id,
          url: doc.data().url,
        });
        // console.log(doc.id, " => ", doc.data());
      });
      this.existingWebsites = websites;
      this.isLoading = false;
    },
    async savePerson () {
      if(!this.$refs.form.validate()) return;
      this.isLoading = true;

      // Add or override the person data
      let personDetails = {
        name: this.personDetails.name,
        type: this.personDetails.type,
        created: firebaseApp.firestore.FieldValue.serverTimestamp(),
        owner: this.uid,
      };
      let personCollection = this.$root.$data.db.collection("person");
      let personRef;
      if(this.isEditing) {
        personRef = personCollection.doc(this.person.id);
        await personRef.set(personDetails);

        // Delete websites that were marked for deletion
        for (let i = 0; i < this.deletedWebsites.length; i++) {
          let websiteId = this.deletedWebsites[i].id;
          try {
            await personRef.collection("website").doc(websiteId).delete();
          } catch (error) {
            console.error("Error removing document: ", error);
          }

          // Delete linked images
          let imagesSnapshot;
          try {
            imagesSnapshot = await this.$root.$data.db.collection('image').where('websiteId', '==', websiteId).get();
          } catch (error) {
            console.error("Error removing document: ", error);
            continue;
          }
          imagesSnapshot.forEach(function(doc) {
            doc.ref.delete();
          });

          try {
            // Decrement the number of images of this user
            await this.userDocQuery.update({
              numImages: firebaseApp.firestore.FieldValue.increment(-imagesSnapshot.size),
            });
          } catch (error) {
            console.error("Error decrementing images: ", error);
            continue;
          }
        }
      } else {
        personRef = await personCollection.add(personDetails);
        await this.userDocQuery.update({
          numPersons: firebaseApp.firestore.FieldValue.increment(1),
        });
      }

      // Add the new websites
      for (let i = 0; i < this.websites.length; i++) {
        let url = this.websites[i].url;
        if(!url) {
          continue;
        }

        try {
          await personRef.collection("website").add({
            url: url,
            created: firebaseApp.firestore.FieldValue.serverTimestamp(),
          });
        } catch (error) {
          console.error("Error adding document: ", error);
        }
      }

      let websitesDiff = this.websites.length - this.deletedWebsites.length;
      if(websitesDiff !== 0) {
        // Update the number of websites of this user
        try {
          await this.userDocQuery.update({
            numWebsites: firebaseApp.firestore.FieldValue.increment(websitesDiff),
          });
        } catch (error) {
          console.error("Error reducing websites of user: ", error);
        }

      }

      this.isLoading = false;
      this.$emit('created');
    },
    openUrl (url) {
      if (!url.match(/^https?:\/\//i)) {
        url = 'http://' + url;
      }
      window.open(url , '_blank');
    },
  },
  mounted() {
    if (this.isEditing) {
      this.personDetails = this.person;
      this.websites = [];
      this.fetchPersonWebsites();
    }
  },
}
</script>
